module.exports = __webpack_public_path__ + "static/img/4 2017.10 创新创业大赛.80fdab0a.png";